import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import type { TeacherCourseJoinCodeProps } from '@edu-frontend/modules/src/entities/user';

import { teacherKPKsSelectors } from '../store/selectors';
import { getCodeErrorMessageId } from '../utils';

import { useJoinCourseByCode } from './useJoinCourseByCode';

/** Хук возвращает пропсы для JoinCode из monoui  */
export function useJoinCodeProps(): Omit<TeacherCourseJoinCodeProps, 'deleteParamFromQuery'> {
    const intl = useIntl();

    const onSubmit = useJoinCourseByCode();

    const progress = useSelector(teacherKPKsSelectors.getPostTeacherKPKJoinByCodeLoading);
    const errorId = getCodeErrorMessageId(useSelector(teacherKPKsSelectors.getJoinByCodeErrorId));

    return {
        onSubmit,
        progress,
        errorText: !progress && errorId ? intl.formatMessage({ id: errorId }) : undefined,
    };
}
